import { useTranslation } from "react-i18next";

import { Button } from "../../../../components/Button";
import { useWardLabel } from "../../../../hooks/useWardLabel";
import {
  ButtonContainer,
  Message,
  ModalContainer,
  Title,
} from "../WardPublishedProtocolModal/WardPublishedProtocolModal.styles";
import { CancelButton } from "./ChangeWardModal.styles";

type ChangeWardModalProps = {
  onConfirm: () => void;
  onCancel: () => void;
};

export function ChangeWardModal({ onConfirm, onCancel }: ChangeWardModalProps) {
  const { t } = useTranslation();
  const { singularLower } = useWardLabel();

  return (
    <ModalContainer>
      <Title>
        {t("protocols_changeWardModal_title", { ward: singularLower })}
      </Title>
      <Message>
        {t("protocols_changeWardModal_message", { ward: singularLower })}
      </Message>
      <ButtonContainer>
        <Button
          label={t("protocols_changeWardModal_confirm", {
            ward: singularLower,
          })}
          type="button"
          onClick={onConfirm}
        />
        <CancelButton onClick={onCancel}>{t("common_cancel")}</CancelButton>
      </ButtonContainer>
    </ModalContainer>
  );
}
